const d = document;
const w = window;
const types = {
	b: 'boolean',
	f: 'function',
	s: 'string',
	o: 'object',
	u: 'undefined',
	n: 'number',
	e: 'element',
	a: 'array',
	j: 'json',
};
const type_of = (type) => (a) => typeof a === types[type];

export const is = {
	set: (a) => typeof a !== types.u,
	str: type_of('s'),
	int: type_of('n'),
	fnc: type_of('f'),
	und: type_of('u'),
	bol: type_of('b'),
	obj: (a) => !!a && a !== '[object Object]' && a.toString() === '[object Object]',
	nll: (a) => a === null,
	arr: (a) => Array.isArray(a),
	ele: (a) => !!a && a.nodeType === 1,
};

export const dash_case = (str) => str.replace(/\s+|_+/g, '-');

export const camel_case = (_a /*<string*>*/) =>
	_a.replace(/(?:-|_|\s)+?(\w)/g, (_, _alpha) => _alpha.toUpperCase());

export const selectEl = (e, t, n) => {
	var r, i;
	return (
		is.bol(t) && ((n = t), (t = void 0)),
		(r = 'querySelector' + (n ? 'All' : '')),
		(i = (t || document)[r](e)),
		n ? Array.from(i) : i
	);
};

export const createEl = (
	_selector /*<string> selector*/,
	_prop /*<string> or <object>*/
) => {
	var s = _selector.replace(/^\./, '').split(/\./),
		c = d.createElement(s.shift()),
		style = c.style;

	(is.str(_prop) || is.int(_prop)) && (c.textContent = _prop);

	if (is.obj(_prop))
		for (var k in _prop) {
			k in c ? (c[k] = _prop[k]) : k in style && (style[k] = _prop[k]);
		}
	s.length && (c.className = s.join(' '));
	return c;
};

export const appendEl = (
	_el /*<element> or <array> to use insertBefore*/,
	i /*<element> to be inserted*/
) => {
	is.arr(_el) && _el.length === 2
		? _el[0].insertBefore(i, _el[1])
		: _el.appendChild(i);
	return i;
};

export const createAppend = (
	_el /*<element> or <array> to use insertBefore*/,
	_selector /*<string>*/,
	_prop /*<string> or <object>*/
) => appendEl(_el, createEl(_selector, _prop));

export const findByText = (finder, finding) => {
	const [selector, text] = finding.split(':');
	return Array.from(finder.querySelectorAll(selector)).filter((el) =>
		new RegExp(text).test(el.textContent)
	);
};

export const css = (
	_el /*<element*>*/,
	_key /*<string*>, <json*>*/,
	_val /*<string>*/
) => {
	const style = _el.style;
	return is.set(_val)
		? camel_case(_key) in style && (style[camel_case(_key)] = _val)
		: is.obj(_key)
		? Object.keys(_key).forEach(function (_v) {
				camel_case(_v) in style && (style[camel_case(_v)] = _key[_v]);
		  })
		: parseFloat(
				w.getComputedStyle(_el).getPropertyValue(_key).replace('px', '')
		  );
};

export const hasClass = (_el/*<element>*/, _find/*<string>*/) => (' '+_el.className+' ').indexOf(' '+_find.trim()+' ') !== -1
  
export const addClass = (_el/*<element>*/, _class/*<string>*/) => {
	var clname = _el.className
	_class.split(/\s{1,10}/).forEach(function(cl) {
		if(hasClass(_el, cl)) return
		clname += (clname ? ' ' : '') + cl
	})
	_el.className = clname.trim()
}
  
export const removeClass = (_el/*<element>*/, _class/*<string>*/) => {
	var clname = _el.className
	_class.split(/\s{1,10}/).forEach(function(cl) {
	  if(hasClass(_el, cl)) clname = clname.replace(new RegExp('\\s{0,20}?'+cl+'\\s{0,20}?','g'),'')
	})
	_el.className = clname.trim()
}
  
export const toggleClass = (_el/*<element>*/, _class/*<string>*/) => {
	var added = false, removed = false
	_class.split(/\s{1,10}/).slice(0,2).forEach(function(cl) {
		if(hasClass(_el, cl) && !removed) {
			removeClass(_el, cl)
			removed = true
		} else if(!added) {
			addClass(_el, cl)
			added = true
		}
	})
}

export const animated = (_trans, _call) => {
	var request;
	var prop = {
		cancel: function () {
			this.end(true);
			cancelAnimationFrame(request);
		},
		end: function (e) {
			this.isDone = true;
			this.done && this.done(e);
		},
		isDone: false,
	};
	var start = performance.now();
	var loop = function (time) {
		var current = time - start;
		var progress = current / _trans;
		if (current < _trans) {
			_call(progress);
			request = requestAnimationFrame(loop);
		} else {
			_call(1);
			prop.end(true);
			cancelAnimationFrame(request);
		}
	};
	request = requestAnimationFrame(loop);

	return prop;
};

export const smoothScroll = (_el, _adjust = 90) => {
	const w = window,
		location = w.location;
	const hash = _el.nodeName ? _el.href.split('#')[1] : _el;
	const target = document.getElementById(hash);
	if (hash === '' || !target) return;
	const tar_top = scrollTop(target);
	const w_top = scrollTop(w);
	const isWhenTheSamePosition = w_top === tar_top - _adjust;
	if (isWhenTheSamePosition) return;
	const prog_base = tar_top - _adjust /*extra 90 top for navbarfixed*/ - w_top;
	const ms = (prog_base < 0 ? prog_base * -1 : prog_base) / 5;
	const finms = ms > 1000 ? ms : 1000;
	location.hash = `#${hash}`;
	const animation = animated(finms, function (prog) {
		prog = 1 - Math.pow(1 - prog, 3); // put some extra ease
		scrollTop(w, w_top + prog_base * prog);
	});
	if (w.__smoothScroll && !w.__smoothScroll.isDone) w.__smoothScroll.cancel();
	w.__smoothScroll = animation;
	return animation;
};

export const scrollTop = (e, t) => {
	const root = document.documentElement;
	const n = e === window,
		r = root.scrollTop;
	return (
		n && (e = root),
		t ? (e.scrollTop = parseInt(t)) : n ? r : r + e.getBoundingClientRect().top
	);
};

export const uid = (length = 6, range = 36) => {
	let unid = '';
	for (let i = 0; i < length; i++) {
		unid += Math.floor(Math.random() * range).toString(range);
	}
	return unid;
};

export const SNAPSHOT = process.env.NODE_ENV === "production" && navigator.userAgent === "ReactSnap"